import React from 'react';
import { SmartLink } from 'components/smart-link';
import Chevron from 'assets/icons/chevron-right.svg';
import BestOne from 'assets/icons/bestOption.svg';
import { Button } from 'components/button';
import { IndexContent } from 'components/indexed-content/indexes';
import { ProductType } from '../type';
import * as styles from './product-best-options.module.scss';

type BestOptionsListProps = {
  products: ProductType[];
  indexedContent: IndexContent[];
  onIndexClick: (index: number) => void;
};

const BestOptionsList = (props: BestOptionsListProps) => {
  const { products, indexedContent, onIndexClick } = props;

  return (
    <div className={styles.listContainer}>
      {products.map((product, index) => {
        const isBestOverall = index === 0;
        const filterIndex = indexedContent.find(
          (i) => i.iTitle.toLowerCase().includes(product.name.toLowerCase()),
        );

        return (
          <div key={product.id} className={styles.cardContainer}>
            <div className={styles.titleContainer}>
              {isBestOverall && <BestOne className={styles.bestOption} /> }
              <div className={styles.title}>
                {isBestOverall ? 'Best Overall' : product.title}
              </div>
            </div>
            <img
              src={product.secondaryImage.url}
              className={styles.productImg}
              alt={product.title}
            />
            <div className={styles.name}>{product.name}</div>
            <div className={styles.description}>{product.shortDescription}</div>
            <div className={styles.buttons}>
              <SmartLink to={product.site.link} className={styles.visitButton}>
                {product.site.name}
              </SmartLink>
              {filterIndex && (
                <Button
                  bStyle="link"
                  className={styles.refButton}
                  onClick={() => (onIndexClick(filterIndex.id))}
                >
                  Read review
                  <Chevron />
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { BestOptionsList };
